function roundto(x: number, dp: number) {
  return Math.round(x * Math.pow(10, dp)) / Math.pow(10, dp);
}
// Found in the source code of this site:
// http://www.sengpielaudio.com/calculator-cutoffFrequencies.htm

export default function getBandwidth(centerFreq: number, qFactor: number) {
  const b = Math.sqrt((1 / (2 * qFactor)) * (1 / (2 * qFactor)) + 1);
  const c = 1 / (2 * qFactor);
  const lower = Math.round(1000 * centerFreq * (b - c)) / 1000;
  const upper = Math.round(1000 * centerFreq * (b + c)) / 1000;

  return { lowerFreq: roundto(lower, 3), upperFreq: roundto(upper, 3) };
}
